import React from 'react';
import { Translate } from 'react-redux-i18n';
import {
  PersonneActivationDedoublonnageDTO,
} from '../../../network/api/types/activation/PersonneActivationDedoublonnageDTO';
import Button from '../../common/Button';
import { RattachementBindWithLinkDTO } from '../../../network/api/types/activation/RattachementBindWithLinkDTO';
import collaborateur from '../../../img/intermediatePage/collaborateur.svg';

type Props = {
  account: PersonneActivationDedoublonnageDTO,
  endForm: () => void | undefined,
  isLoading: boolean,
};

class DoublonAccountTile extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { account, endForm, isLoading } = this.props;
    // if this tile needs to be reused, the content could be passed through a child prop
    return (
      <div className="account-tile">
        <img src={collaborateur} alt="collaborateur" />
        <div className="account-infos">
          <div className="account-fullname">
            {(account.nomDeNaissance && account.nomUsuel
            && account.nomDeNaissance !== account.nomUsuel)
              ? <Translate value="ACTIVATION.FULL_NAME" prenom={account.prenom} nomDeNaissance={account.nomDeNaissance} nomUsuel={account.nomUsuel} />
              : <Translate value="ACTIVATION.FIRST_AND_LAST_NAME" prenom={account.prenom} nomUsuel={account.nomUsuel || account.nomDeNaissance} />}
          </div>
          <div className="account-username">
            {account.pseudo}
          </div>
        </div>
        <div className="account-infos">
          {account.emailPersonnel && (
            <Translate value="ACTIVATION.PERSONAL_EMAIL" email={account.emailPersonnel} />
          )}
          {account.emailDeSecours && (
            <Translate value="ACTIVATION.RESCUE_EMAIL" email={account.emailDeSecours} />
          )}
          {account.dateCreation && (
            <Translate value="ACTIVATION.CREATED_WHEN" date={account.dateCreation} />
          )}
        </div>
        {!!account.rattachements?.length && (
          <div className="account-infos">
            <Translate value="ACTIVATION.RATTACHMENTS" />
            <ul>
              {account.rattachements.map((rattachement: RattachementBindWithLinkDTO) => (
                <li>
                  {rattachement.ctmTypeLien}
                  {' @ '}
                  {rattachement.ctmEntityName}
                </li>
              ))}
            </ul>
          </div>
        )}
        {endForm !== undefined && (
          <Button
            type="primary"
            buttonType="button"
            i18nKey="ACTIVATION.DELETE_AND_END"
            isLoading={isLoading}
            onClick={endForm}
          />
        )}
      </div>
    );
  }
}

export default DoublonAccountTile;
